import { useState, useEffect } from 'react';
import { useLanguage } from '@/contexts/AppContext';

interface CountdownTimerProps {
  initialMinutes: number;
  status: 'preparing' | 'ready' | 'completed';
}

const translations = {
  ko: {
    status: '상태',
    estimatedTime: '예상 시간',
    readyNow: '지금 픽업 가능합니다!'
  },
  es: {
    status: 'Estado',
    estimatedTime: 'Tiempo estimado',
    readyNow: '¡Listo para recoger ahora!'
  },
  en: {
    status: 'Status',
    estimatedTime: 'Estimated time',
    readyNow: 'Ready to pick up now!'
  }
};

export function CountdownTimer({ initialMinutes, status }: CountdownTimerProps) {
  const { language } = useLanguage();
  const [timeRemaining, setTimeRemaining] = useState(initialMinutes * 60); // Convert minutes to seconds
  const t = translations[language];
  
  useEffect(() => {
    const initialSeconds = initialMinutes * 60;
    setTimeRemaining(initialSeconds);

    if (status === 'ready' || initialSeconds <= 0) return;
    
    const timer = setInterval(() => {
      setTimeRemaining(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [status, initialMinutes]);
  
  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;
  const displayTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  
  return (
    <p className="text-[clamp(13px,3.2vw,15px)] font-bold text-foreground tabular-nums">
      {status === 'ready' 
        ? t.readyNow
        : timeRemaining <= 0
          ? t.readyNow
          : displayTime
      }
    </p>
  );
}
